<div class="cmps-cdk-font-size-18p cmps-cdk-font-bold">
    {{ _i18n._11194_CONNECTION_SCORE | translate }}
</div>
<div
    class="cmps-cdk-border-radius-4p cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-bg-color-grey-200 cmps-cdk-mx-1 cmps-cdk-flex-grow-1"
>
    <div class="cmps-cdk-mx-0dot5">
        {{ _i18n._11195___ALIGNMENT | translate }}
    </div>
    <div
        class="cmps-ca-score-section--bar cmps-cdk-border-radius-6p cmps-cdk-bg-color-grey-300 cmps-cdk-mx-0dot5 cmps-cdk-flex-grow-1 cmps-cdk-overflow-hidden"
    >
        <div
            class="cmps-cdk-border-radius-6p cmps-cdk-bg-gradient-green-100-0 cmps-cdk-h-100p"
            [style.width.%]="(scorePercent ?? 0) * 100"
        ></div>
    </div>
    <div class="cmps-cdk-mx-0dot5 cmps-cdk-font-size-18p cmps-cdk-font-bold">
        {{ scorePercent ?? 0 | cmpsPercent: '1.0-0' }}
    </div>
</div>
<div *ngIf="!hideInfo">
    <cmps-icon
        class="cmps-cdk-fill-grey-400"
        svgIcon="information"
        [cmpsOverlayTrigger]="legendTpl"
        placement="bottom-right"
    ></cmps-icon>
</div>

<ng-template #legendTpl>
    <cmps-ca-score-section-legend></cmps-ca-score-section-legend>
</ng-template>
